// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CancelConfirmButtonPair{margin-bottom:8px}.CancelConfirmButtonPair.ButtonPairFloat-right .ActionButton{margin-right:8px}.CancelConfirmButtonPair.ButtonPairFloat-left .ActionButton{margin-left:8px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
